import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from './navBar';
import mikan from '../images/appHomeAssets/onikanji-review-button-graphic.webp';

// Shown inside the Android app wherever the website would offer a purchase.
// Google Play doesn't allow our Stripe checkout in the app, and until Play
// Billing is added the app simply doesn't sell anything. Deliberately no link
// or price pointing elsewhere (Play's anti-steering rules).
function AppMembershipNotice({ kind = 'membership' }) {
    const title = kind === 'coins' ? "Coins aren't sold in the app yet" : "Memberships aren't available in the app yet";
    return (
        <div className="font-noto-sans-jp min-h-screen bg-mainBackgroundColor">
            <Navbar />
            <div className="max-w-xl mx-auto px-4 py-10 sm:py-16">
                <div className="bg-lightOrangeBackground rounded-xl shadow-blueBoxShadow p-6 sm:p-8 text-center flex flex-col items-center gap-4">
                    <img src={mikan} alt="" className="w-32 h-32 object-contain" />
                    <h1 className="text-2xl sm:text-3xl font-bold text-logoColor">{title}</h1>
                    <p className="text-lightBlueText">
                        Levels 1–3 are free in the app, and if you're already a member, every level and feature is unlocked here too.
                    </p>
                    <Link
                        to="/home"
                        className="mt-2 bg-darkOrangeColor hover:bg-darkOrangeColorButtonHover text-white font-semibold text-lg px-6 py-3 rounded-lg shadow-md transition-all"
                    >
                        Back to my dashboard
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default AppMembershipNotice;
